export const POSITIONS = {
  right: 'right',
  left: 'left',
  center: 'center',
};
